import { OpalApiComponent } from '@opallabs/api/v3'

type GenericUser = {
  [key: string]: any
  uuid: string
  name: string
}

export const resourceObject = (
  member: GenericUser
): OpalApiComponent<'V3', 'user'> => ({
  id: member.uuid,
  type: 'user',
  attributes: {
    full_name: member.name,
    created_at: new Date().toISOString(),
    email: '',
    first_name: '',
    last_name: '',
    is_active: true,
    title: '',
    transliterated_full_name: '',
    updated_at: new Date().toISOString(),
    legacy_id: '',
  },
  relationships: { profile: { data: null }, workspaces: { data: [] } },
  links: { v2_request: '' },
})
